import { format } from 'date-fns';

import { useReport } from './hooks/use-context';

export const Members = () => {
  const { header, body } = useReport();

  const infoSection = body?.sections?.find(
    (section) => section.section_name === 'Informações',
  );

  const empresaTerceira =
    infoSection?.questions.find(
      (question) => question.name === 'Informe a empresa terceira:',
    )?.answers[0]?.content || '';

  const participanteTerceiro =
    infoSection?.questions.find(
      (question) => question.name === 'Informe o nome do participante terceiro:',
    )?.answers[0]?.content || '';

  return (
    <div style={{ fontSize: '10px', breakInside: 'avoid', marginTop: '1rem' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '5fr 8fr 5fr 12fr',
          borderTop: '1px #000 solid',
          borderLeft: '1px #000 solid',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateRows: 'repeat(3, 1fr)',
          }}
        >
          <div
            style={{
              gridRow: '1 / span 3',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontWeight: 'bold',
              padding: '0px 5px',
              borderRight: '1px #000 solid',
              borderBottom: '1px #000 solid',
            }}
          >
            Participantes
          </div>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateRows: '1fr 1fr 1fr',
          }}
        >
          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontWeight: 'bold',
              borderRight: '1px #000 solid',
              borderBottom: '1px #000 solid',
              backgroundColor: '#d3d3d3',
            }}
          >
            Nome
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              borderRight: '1px #000 solid',
              borderBottom: '1px #000 solid',
            }}
          >
            <div>{header?.author_full_name || '-'}</div>
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              borderRight: '1px #000 solid',
              borderBottom: '1px #000 solid',
            }}
          >
            <div>{participanteTerceiro || '-'}</div>
          </div>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateRows: '1fr 1fr 1fr',
          }}
        >
          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontWeight: 'bold',
              borderRight: '1px #000 solid',
              borderBottom: '1px #000 solid',
              backgroundColor: '#d3d3d3',
            }}
          >
            Cargo/Função
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              borderRight: '1px #000 solid',
              borderBottom: '1px #000 solid',
            }}
          >
            <div>Inspetor / Gestor</div>
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              borderRight: '1px #000 solid',
              borderBottom: '1px #000 solid',
            }}
          >
            <div>{empresaTerceira ? `Terceiro (${empresaTerceira})` : 'Terceiro'}</div>
          </div>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateRows: '1fr 1fr 1fr',
          }}
        >
          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              fontWeight: 'bold',
              borderRight: '1px #000 solid',
              borderBottom: '1px #000 solid',
              backgroundColor: '#d3d3d3',
            }}
          >
            Validação / Assinatura
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              borderRight: '1px #000 solid',
              borderBottom: '1px #000 solid',
            }}
          >
             {header?.event_finished_at || '-'}
          </div>

          <div
            style={{
              display: 'flex',
              padding: '4px',
              justifyContent: 'center',
              alignItems: 'center',
              borderRight: '1px #000 solid',
              borderBottom: '1px #000 solid',
            }}
          >
            (Assinatura Física ou Digital)
          </div>
        </div>
      </div>
    </div>
  );
};
